import { isCoach, isOwner } from '../auth/roles';
import type { AccessProfile } from '../api/schemas';
import type { StoredSession } from '../auth/session-store';
import { PROFILE_LABEL } from '../features/permissions/catalog';
import { initialOf } from './customers';
import { staffName, useBusiness } from './useBusiness';

type Business = ReturnType<typeof useBusiness>;

export type WhoAmI = { name: string; roleWord: string; initials: string };

/**
 * Who is signed in, the way the panel names them: a coach reads their own
 * name first, everyone else reads the business; the role is Titular, Coach,
 * the person's own role (Estilista, Barbero), their profile (Recepción,
 * Administración) once the panel knows it, or Equipo.
 */
export function whoAmI(
  session: Pick<StoredSession, 'role' | 'staffMemberId'> | null | undefined,
  business: Business,
  profile?: AccessProfile,
): WhoAmI {
  const coach = isCoach(session);
  const coachRole = coach ? business?.staff.find((member) => member.id === session?.staffMemberId)?.role : undefined;
  const roleWord = isOwner(session?.role)
    ? 'Titular'
    : coach
      ? business?.category === 'classstudio'
        ? 'Coach'
        : (coachRole ?? 'Equipo')
      : profile
        ? PROFILE_LABEL[profile]
        : 'Equipo';
  const coachName = coach ? staffName(business, session?.staffMemberId) : undefined;
  const name = coachName ?? business?.name ?? 'Tu negocio';
  return { name, roleWord, initials: initialsOf(name) };
}

/** "Casco Fade Club" -> "CF"; one word keeps its first letter. */
export function initialsOf(name: string): string {
  const words = name.trim().split(/\s+/).filter((word) => /\p{L}/u.test(word));
  if (words.length < 2) return initialOf(name);
  return `${initialOf(words[0]!)}${initialOf(words[1]!)}`;
}
